import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserAudit } from 'src/app/users-module/models/userLight';
import { UserService } from 'src/app/users-module/services/user.service';

@Component({
  selector: 'app-processor-audit-dialog',
  templateUrl: './processor-audit-dialog.component.html',
  styleUrls: ['./processor-audit-dialog.component.less']
})
export class ProcessorAuditDialogComponent implements OnInit, OnDestroy {

  processors: UserAudit[] = [];
  loading: boolean = false;
  selectedProcessor: number;
  dateToAudit: Date;
  partyOn : Subject<any> = new Subject<any>();

  constructor(public usrs: UserService, public toast: ToastrService, public modalRef: NgbModal) {
    
  }
  ngOnDestroy(): void {
    
  }

  ngOnInit(): void {
    this.loading = true;
    this.usrs.FetchUsersForAuditReport().pipe(
      tap((_:UserAudit[]) => {
        this.processors = _;
      },
      err => {
        this.toast.error('Error fetching processors list', 'Error', { closeButton: true, disableTimeOut: true });
      },
      () => {
        this.loading = false;
        console.log('loaded: ', this.processors)
      })
    ).subscribe();

  }

  cancel() {
    this.modalRef.dismissAll();
  }

  download() {
    //quick checks:
    if(!this.selectedProcessor) {
      this.toast.error('Please select a processor.');
      return;
    }
    if(!this.dateToAudit) {
      this.dateToAudit = new Date();
    }
    console.log(this.selectedProcessor);
    console.log(this.dateToAudit);
    var vals = {};
    vals['userId'] = this.selectedProcessor;
    vals['auditDate'] = this.dateToAudit;
    this.partyOn.next(vals);
  }
}